import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.night');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-night',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.night/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.night-page {
  position: relative;
  isolation: isolate;
  min-height: 100svh;
  overflow: hidden;
  background: radial-gradient(circle at 50% 115%, rgba(109, 40, 217, 0.14), transparent 38%), linear-gradient(160deg, #070812 0%, #0b0c19 48%, #060711 100%);
}

.night-aurora {
  position: absolute;
  z-index: -2;
  top: -440px;
  left: 50%;
  width: 900px;
  height: 720px;
  border-radius: 9999px;
  background: radial-gradient(circle, rgba(139, 92, 246, 0.16) 0%, rgba(76, 29, 149, 0.07) 42%, transparent 70%);
  filter: blur(10px);
  transform: translateX(-50%);
  pointer-events: none;
}

.star-field {
  position: absolute;
  z-index: -1;
  inset: 0;
  pointer-events: none;
}

.star {
  position: absolute;
  width: 3px;
  height: 3px;
  border-radius: 9999px;
  background: rgba(221, 214, 254, 0.82);
  box-shadow: 0 0 10px rgba(196, 181, 253, 0.6);
  animation: twinkle 4s ease-in-out infinite;
}

.star-one {
  top: 18%;
  left: 15%;
}

.star-two {
  top: 27%;
  right: 19%;
  width: 2px;
  height: 2px;
  animation-delay: 0.8s;
}

.star-three {
  top: 64%;
  left: 9%;
  width: 2px;
  height: 2px;
  animation-delay: 1.6s;
}

.star-four {
  right: 11%;
  bottom: 23%;
  animation-delay: 2.2s;
}

.star-five {
  top: 11%;
  left: 62%;
  width: 2px;
  height: 2px;
  animation-delay: 2.9s;
}

.star-six {
  left: 29%;
  bottom: 15%;
  animation-delay: 3.4s;
}

.moon-mark {
  position: relative;
  width: 38px;
  height: 38px;
  overflow: hidden;
  border: 1px solid rgba(196, 181, 253, 0.2);
  border-radius: 9999px;
  background: rgba(124, 58, 237, 0.08);
  box-shadow: inset 0 0 18px rgba(139, 92, 246, 0.07);
}

.moon-mark::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 9px;
  width: 18px;
  height: 18px;
  border-radius: 9999px;
  background: #c4b5fd;
  box-shadow: 0 0 20px rgba(196, 181, 253, 0.32);
}

.moon-mark::after {
  content: "";
  position: absolute;
  top: 4px;
  left: 16px;
  width: 18px;
  height: 18px;
  border-radius: 9999px;
  background: #0b0c19;
}

.status-label {
  border: 1px solid rgba(196, 181, 253, 0.14);
  background: rgba(124, 58, 237, 0.08);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

@keyframes twinkle {
  0%, 100% {
    opacity: 0.2;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1.15);
  }
}
@media (prefers-reduced-motion: reduce) {
  .star {
    animation: none;
  }
}`],
})
export class PageNightComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public navigateHome(event?: MouseEvent) {
        if (!event || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
            return;
        }

        event.preventDefault();
        this.service.href('/');
    }
}

export default PageNightComponent;